__turbopack_context__.v({
  "active": "style-module-scss-module__pljVIq__active",
  "field": "style-module-scss-module__pljVIq__field",
  "fieldWrapper": "style-module-scss-module__pljVIq__fieldWrapper",
  "invertedColors": "style-module-scss-module__pljVIq__invertedColors",
  "label": "style-module-scss-module__pljVIq__label",
  "radioButton": "style-module-scss-module__pljVIq__radioButton",
  "textarea": "style-module-scss-module__pljVIq__textarea",
});
